import { render, staticRenderFns } from "./FormResearch.vue?vue&type=template&id=3ed80522&scoped=true"
import script from "./FormResearch.vue?vue&type=script&lang=js"
export * from "./FormResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed80522",
  null
  
)

export default component.exports